import { useState, useEffect, useCallback, useRef } from "react";

const ADMIN_PIN = "1234";
const CSOPORTOK_SORREND = ["Sör","Bor","Pálinka","Koktél","Üdítő","Alkoholmentes","Meleg ital","Egyéb"];
const IKONOK = ["🍺","🍷","🥂","🥃","🍸","🍹","🧃","☕","💧","🥤","🍶","🫖","🧉","🍾","🫗","🫙","🧊","🍵"];
const RENDSZER = new Set(["Esemény","Típus","Dátum","Vendégek","Megjegyzés","Étkezés ár (RSD/fő)","Módosítások"]);

function today() { return new Date().toISOString().split("T")[0]; }
function formatDatum(d) { if(!d) return ""; return new Date(d).toLocaleDateString("hu-HU",{year:"numeric",month:"long",day:"numeric"}); }
function fmtRSD(n) { return new Intl.NumberFormat("sr-RS").format(Math.round(n))+" RSD"; }
function formatTs(ts) { if(!ts) return ""; const d=new Date(ts); return d.toLocaleDateString("hu-HU",{month:"short",day:"numeric"})+" "+d.toLocaleTimeString("hu-HU",{hour:"2-digit",minute:"2-digit"}); }

function pageToRow(page) {
  const p=page.properties;
  const row={id:page.id,notionUrl:page.url};
  Object.entries(p).forEach(([key,val])=>{
    if(val.type==="title") row[key]=val.title?.[0]?.plain_text||"";
    else if(val.type==="number") row[key]=val.number||0;
    else if(val.type==="select") row[key]=val.select?.name||"";
    else if(val.type==="date") row[key]=val.date?.start||"";
    else if(val.type==="rich_text") row[key]=val.rich_text?.[0]?.plain_text||"";
  });
  try { row._mod=JSON.parse(row["Módosítások"]||"{}"); } catch { row._mod={}; }
  return row;
}

const inp={width:"100%",background:"#0f0d0a",border:"1px solid #4a3520",borderRadius:8,padding:"10px 12px",color:"#e8d5a0",fontSize:14,fontFamily:"Georgia, serif",boxSizing:"border-box",outline:"none"};
const lbl={fontSize:11,color:"#8a6a3a",letterSpacing:2,display:"block",marginBottom:6,textTransform:"uppercase"};
const btn=(bg,color,extra={})=>({background:bg,color,border:"none",borderRadius:8,padding:"10px 16px",fontSize:13,cursor:"pointer",fontFamily:"Georgia, serif",...extra});

function Spinner({small}) {
  return <span style={{display:"inline-block",width:small?14:20,height:small?14:20,border:`${small?2:3}px solid #5a4a30`,borderTopColor:"#e8c870",borderRadius:"50%",animation:"spin 0.7s linear infinite"}}/>;
}

function Modal({borderColor="#5a4020",children}) {
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.88)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:16}}>
      <div style={{background:"#1a1208",border:`1px solid ${borderColor}`,borderRadius:16,padding:24,width:"100%",maxWidth:380,maxHeight:"90vh",overflowY:"auto"}}>
        {children}
      </div>
    </div>
  );
}

export default function App() {
  const [page,setPage]=useState("tracker");
  const [pinModal,setPinModal]=useState(false);
  const [pinInput,setPinInput]=useState("");
  const [pinError,setPinError]=useState(false);
  const [appUnlocked,setAppUnlocked]=useState(false);
  const [appPin,setAppPin]=useState("");
  const [appPinError,setAppPinError]=useState(false);

  const appPinSubmit=async()=>{
    try {
      const res=await fetch("/api/login",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({pin:appPin})});
      if(res.ok){setAppUnlocked(true);}
      else{setAppPinError(true);setAppPin("");}
    } catch {
      setAppPinError(true);setAppPin("");
    }
  };

  const goAdmin=()=>{setPinModal(true);setPinInput("");setPinError(false);};
  const pinSubmit=()=>{
    if(pinInput===ADMIN_PIN){setPinModal(false);setPage("admin");}
    else{setPinError(true);setPinInput("");}
  };

  if(!appUnlocked) return (
    <div style={{minHeight:"100vh",background:"#0f0d0a",color:"#f0e8d8",fontFamily:"Georgia, serif",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      <div style={{background:"#1a1208",border:"1px solid #4a3520",borderRadius:20,padding:"40px 32px",width:"100%",maxWidth:340,textAlign:"center"}}>
        <div style={{fontSize:48,marginBottom:16}}>🍷</div>
        <div style={{fontSize:11,letterSpacing:4,color:"#8a6a3a",textTransform:"uppercase",marginBottom:6}}>Géza Kátai Tanyája</div>
        <h1 style={{fontSize:20,fontWeight:"normal",color:"#e8d5a0",margin:"0 0 32px"}}>Ital Fogyasztás</h1>
        <input
          type="password" value={appPin}
          onChange={e=>{setAppPin(e.target.value);setAppPinError(false);}}
          onKeyDown={e=>e.key==="Enter"&&appPinSubmit()}
          placeholder="PIN kód" autoFocus
          style={{...inp,textAlign:"center",fontSize:24,letterSpacing:10,marginBottom:10}}
        />
        {appPinError&&<p style={{color:"#d07070",fontSize:12,margin:"0 0 10px"}}>Hibás PIN kód</p>}
        <button onClick={appPinSubmit} style={{...btn("#8a4a1a","#f0e8d8"),width:"100%",fontSize:15,padding:"12px"}}>Belépés</button>
      </div>
    </div>
  );

  return (
    <div style={{minHeight:"100vh",background:"#0f0d0a",color:"#f0e8d8",fontFamily:"Georgia, serif"}}>
      <style>{`
        @keyframes spin{to{transform:rotate(360deg)}}
        input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none}
        .compact-search{display:none}
        @media (min-width: 700px) {
          .tracker-header{padding:7px 12px!important;min-height:42px;box-sizing:border-box}
          .tracker-brand-tagline{display:none!important}
          .tracker-brand-title{font-size:17px!important}
          .tracker-search{display:none!important}
          .tracker-tabs{padding:4px 12px 0!important}
          .tracker-tabs.single-event{display:none!important}
          .tracker-tabs-inner{padding-bottom:3px!important}
          .tracker-tabs-inner button{padding-top:5px!important;padding-bottom:5px!important}
          .event-tab-date{display:none!important}
          .tracker-active{padding:6px 12px 62px!important}
          .event-card{padding:7px 11px!important;margin-bottom:7px!important}
          .event-details{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;width:100%;gap:8px 14px}
          .guest-controls,.event-price-controls{margin-top:0!important}
          .compact-search{display:block;width:170px;flex:0 0 170px;background:#0f0d0a;border:1px solid #4a3520;border-radius:7px;color:#e8d5a0;font:16px Georgia,serif;padding:8px 10px;box-sizing:border-box;outline:none}
          .drink-groups{display:block;column-count:2;column-gap:12px}
          .drink-group{break-inside:avoid;page-break-inside:avoid;margin:0 0 8px!important;min-width:0}
          .drink-group-title{margin-bottom:4px!important;font-size:11px!important}
          .drink-items{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr));gap:6px!important}
          .drink-item{padding:7px 8px!important;border-radius:7px!important;min-width:0;min-height:80px;box-sizing:border-box;flex-direction:column;align-items:stretch!important;justify-content:space-between!important}
          .drink-item-main{gap:7px!important;width:100%}
          .drink-item-icon{font-size:20px!important}
          .drink-item-name{font-size:15px!important}
          .drink-item-count{display:none!important}
          .drink-controls{gap:5px!important;justify-content:center;width:100%}
          .drink-controls>button{width:36px!important;height:36px!important;font-size:23px!important}
          .drink-controls>input{width:46px!important;font-size:19px!important;padding:4px 2px!important}
          .tracker-actions{padding:6px 12px!important;flex-direction:row!important;gap:8px!important}
          .tracker-actions>button{padding:10px!important;font-size:15px!important;border-radius:9px!important}
        }
        @media (min-width: 1100px) {
          .compact-search{width:210px;flex-basis:210px}
          .drink-groups{column-count:3;column-gap:16px}
          .drink-item{min-height:82px;padding:8px 10px!important}
          .drink-item-name{font-size:16px!important}
          .drink-controls>button{width:38px!important;height:38px!important;font-size:25px!important}
          .drink-controls>input{width:48px!important;font-size:20px!important}
        }
      `}</style>
      {page==="tracker" && <TrackerPage onAdminClick={goAdmin}/>}
      {page==="admin"   && <AdminPage onBack={()=>setPage("tracker")}/>}
      {pinModal && (
        <Modal borderColor="#5a4a70">
          <h3 style={{margin:"0 0 6px",color:"#c0a0e0",fontWeight:"normal",fontSize:17,textAlign:"center"}}>🔒 Admin belépés</h3>
          <p style={{fontSize:12,color:"#7a6a90",textAlign:"center",margin:"0 0 18px"}}>Add meg a PIN kódot</p>
          <input type="password" value={pinInput} onChange={e=>{setPinInput(e.target.value);setPinError(false);}} onKeyDown={e=>e.key==="Enter"&&pinSubmit()} placeholder="••••" autoFocus style={{...inp,textAlign:"center",fontSize:22,letterSpacing:8,marginBottom:10}}/>
          {pinError && <p style={{color:"#d07070",fontSize:12,textAlign:"center",margin:"0 0 10px"}}>Hibás PIN</p>}
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>setPinModal(false)} style={{...btn("transparent","#6a5040"),flex:1,border:"1px solid #3a2a18"}}>Mégse</button>
            <button onClick={pinSubmit} style={{...btn("#5a3a8a","#e0c0ff"),flex:2}}>Belépés</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

function TrackerPage({onAdminClick}) {
  const [esemenyek,setEsemenyek]=useState([]);
  const [arak,setArak]=useState({});
  const [konfig,setKonfig]=useState([]); // [{id,Tétel,Ikon,Csoport,Sorrend}]
  const [aktEsemeny,setAktEsemeny]=useState(null);
  const [osszes,setOsszes]=useState(false);
  const [loading,setLoading]=useState(false);
  const [saving,setSaving]=useState(false);
  const savingRef=useRef(false);
  const [statusMsg,setStatusMsg]=useState("");
  const [inputCache,setInputCache]=useState({});
  const [totalModal,setTotalModal]=useState(null); // "final" | "current"
  const [kereső,setKereső]=useState("");
  const [tsTooltip,setTsTooltip]=useState(null);
  const [torlésModal,setTorlésModal]=useState(null);
  const [esemenyNevModal,setEsemenyNevModal]=useState(false);
  const [esemenyNevInput,setEsemenyNevInput]=useState("");
  const [osszesMod,setOsszesMod]=useState("month");
  const [osszesPeriod,setOsszesPeriod]=useState("");

  const [ujEsemenyModal,setUjEsemenyModal]=useState(false);
  const [ujNev,setUjNev]=useState("");
  const [ujTipus,setUjTipus]=useState("Vacsora");
  const [ujDatum,setUjDatum]=useState(today());
  const [ujVendegek,setUjVendegek]=useState("");
  const [ujEtkezesAr,setUjEtkezesAr]=useState("");

  const status=(msg,ms=2500)=>{setStatusMsg(msg);if(ms)setTimeout(()=>setStatusMsg(""),ms);};

  const load=useCallback(async()=>{
    setLoading(true);setStatusMsg("Betöltés...");
    try {
      const [eRes,aRes,kRes]=await Promise.all([
        fetch("/api/esemenyek").then(r=>{if(!r.ok)throw new Error();return r.json();}),
        fetch("/api/arak").then(r=>{if(!r.ok)throw new Error();return r.json();}),
        fetch("/api/konfig").then(r=>{if(!r.ok)throw new Error();return r.json();}),
      ]);
      if(eRes.results) setEsemenyek(eRes.results.map(pageToRow).sort((a,b)=>(b.Dátum||"").localeCompare(a.Dátum||"")));
      if(aRes.results) { const m={}; aRes.results.map(pageToRow).forEach(r=>{if(r["Tétel"])m[r["Tétel"]]=r["Ár (RSD)"]||0;}); setArak(m); }
      if(kRes.results) setKonfig(kRes.results.map(pageToRow).sort((a,b)=>(a.Sorrend||99)-(b.Sorrend||99)));
      setStatusMsg("");
    } catch(e){status("⚠️ Betöltési hiba",0);}
    setLoading(false);
  },[]);

  const refreshEvents=useCallback(async()=>{
    if(savingRef.current)return;
    try {
      const res=await fetch("/api/esemenyek");
      if(!res.ok)throw new Error();
      const data=await res.json();
      if(data.results)setEsemenyek(data.results.map(pageToRow).sort((a,b)=>(b.Dátum||"").localeCompare(a.Dátum||"")));
    } catch {}
  },[]);

  useEffect(()=>{
    load();
    const timer=setInterval(refreshEvents,5000);
    const onFocus=()=>refreshEvents();
    const onVisibility=()=>{if(document.visibilityState==="visible")refreshEvents();};
    window.addEventListener("focus",onFocus);
    document.addEventListener("visibilitychange",onVisibility);
    return()=>{clearInterval(timer);window.removeEventListener("focus",onFocus);document.removeEventListener("visibilitychange",onVisibility);};
  },[load,refreshEvents]);
  useEffect(()=>{savingRef.current=saving;},[saving]);
  useEffect(()=>{
    if(aktEsemeny){const f=esemenyek.find(e=>e.id===aktEsemeny.id);if(f)setAktEsemeny(f);}
    else if(!osszes&&esemenyek.length===1)setAktEsemeny(esemenyek[0]);
  },[esemenyek]);

  const esemenyLetrehozas=async()=>{
    if(!ujNev.trim())return;
    setSaving(true);setStatusMsg("Létrehozás...");
    try {
      const res=await fetch("/api/esemenyek",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({nev:ujNev,tipus:ujTipus,datum:ujDatum,vendegek:parseInt(ujVendegek)||0,etkezesAr:parseFloat(ujEtkezesAr)||0})});
      const data=await res.json();
      setUjEsemenyModal(false);setUjNev("");setUjVendegek("");setUjEtkezesAr("");
      status("✓ Létrehozva");
      await load();
      if(data.id) setTimeout(()=>setEsemenyek(prev=>{const f=prev.find(e=>e.id===data.id);if(f)setAktEsemeny(f);return prev;}),300);
    } catch{status("⚠️ Hiba",0);}
    setSaving(false);
  };

  const saveField=async(esemeny,field,value)=>{
    if(!esemeny?.id)return;
    savingRef.current=true;setSaving(true);setStatusMsg("Mentés...");
    const ts=new Date().toISOString();
    const newMod={...(esemeny._mod||{}),[field]:ts};
    const modJson=JSON.stringify(newMod);
    setEsemenyek(prev=>prev.map(e=>e.id===esemeny.id?{...e,[field]:value,_mod:newMod}:e));
    if(aktEsemeny?.id===esemeny.id)setAktEsemeny(prev=>({...prev,[field]:value,_mod:newMod}));
    try {
      let pv=typeof value==="number"?{number:value}:{rich_text:[{text:{content:String(value)}}]};
      const res=await fetch(`/api/esemenyek/${esemeny.id}`,{method:"PATCH",headers:{"Content-Type":"application/json"},body:JSON.stringify({[field]:pv,"Módosítások":{rich_text:[{text:{content:modJson}}]}})});
      if(!res.ok)throw new Error("Mentési hiba");
      status("✓ Mentve");
    } catch{
      savingRef.current=false;
      await refreshEvents();
      status("⚠️ Nem sikerült menteni",0);
    }
    savingRef.current=false;setSaving(false);
  };

  const saveEsemenyNev=async()=>{
    const ujNev=esemenyNevInput.trim();
    if(!aktEsemeny||!ujNev)return;
    savingRef.current=true;setSaving(true);setStatusMsg("Mentés...");
    try {
      const res=await fetch(`/api/esemenyek/${aktEsemeny.id}`,{method:"PATCH",headers:{"Content-Type":"application/json"},body:JSON.stringify({"Esemény":{title:[{text:{content:ujNev}}]}})});
      if(!res.ok)throw new Error();
      setEsemenyek(prev=>prev.map(e=>e.id===aktEsemeny.id?{...e,Esemény:ujNev}:e));
      setAktEsemeny(prev=>({...prev,Esemény:ujNev}));
      setEsemenyNevModal(false);status("✓ Eseménynév mentve");
    } catch{status("⚠️ Nem sikerült menteni",0);}
    savingRef.current=false;setSaving(false);
  };

  const esemenyTorol=async(esemeny)=>{
    setSaving(true);setStatusMsg("Törlés...");
    try {
      await fetch(`/api/esemenyek/${esemeny.id}`,{method:"DELETE"});
      if(aktEsemeny?.id===esemeny.id)setAktEsemeny(null);
      setEsemenyek(prev=>prev.filter(e=>e.id!==esemeny.id));
      status("✓ Törölve");
    } catch{status("⚠️ Hiba",0);}
    setTorlésModal(null);setSaving(false);
  };

  const lep=(field,delta)=>{
    if(!aktEsemeny)return;
    const uj=Math.max(0,(Number(aktEsemeny[field])||0)+delta);
    setInputCache(p=>{const n={...p};delete n[field];return n;});
    saveField(aktEsemeny,field,uj);
  };
  const setDb=(field,val)=>{
    if(!aktEsemeny)return;
    const szam=parseFloat(val);
    const uj=isNaN(szam)||szam<0?0:szam;
    setInputCache(p=>{const n={...p};delete n[field];return n;});
    saveField(aktEsemeny,field,uj);
  };
  const setVendegek=(val)=>{
    if(!aktEsemeny)return;
    const szam=parseInt(val,10);
    const uj=isNaN(szam)||szam<0?0:szam;
    setInputCache(p=>{const n={...p};delete n.Vendégek;return n;});
    saveField(aktEsemeny,"Vendégek",uj);
  };

  // Filter konfig by search
  const szurtKonfig=kereső.trim()
    ? konfig.filter(k=>k["Tétel"]?.toLowerCase().includes(kereső.toLowerCase()))
    : konfig;

  const csoportRank=(name)=>{const index=CSOPORTOK_SORREND.indexOf(name);return index<0?999:index;};
  const csoportok=[...new Set(szurtKonfig.map(k=>k.Csoport||"Egyéb"))].sort((a,b)=>csoportRank(a)-csoportRank(b)||a.localeCompare(b,"hu"));
  const mindenCsoport=[...new Set(konfig.map(k=>k.Csoport||"Egyéb"))].sort((a,b)=>csoportRank(a)-csoportRank(b)||a.localeCompare(b,"hu"));
  const periodOptions=[...new Set(esemenyek.map(e=>{
    if(!e.Dátum)return "";
    return osszesMod==="year"?e.Dátum.slice(0,4):e.Dátum.slice(0,7);
  }).filter(Boolean))].sort((a,b)=>b.localeCompare(a));
  const activePeriod=periodOptions.includes(osszesPeriod)?osszesPeriod:(periodOptions[0]||"");
  const osszesEsemenyek=esemenyek.filter(e=>!activePeriod||(osszesMod==="year"?e.Dátum?.startsWith(activePeriod):e.Dátum?.slice(0,7)===activePeriod));
  const periodLabel=(period)=>{
    if(!period)return "Nincs dátum";
    if(osszesMod==="year")return `${period}. év`;
    const [year,month]=period.split("-");
    return new Date(Number(year),Number(month)-1,1).toLocaleDateString("hu-HU",{year:"numeric",month:"long"});
  };

  const calcTotal=()=>{
    if(!aktEsemeny)return{sorok:[],etkezesOssz:0,etkezesArFo:0,vendegek:0};
    const sorok=konfig.filter(k=>Number(aktEsemeny[k["Tétel"]])>0).map(k=>({
      id:k["Tétel"],ikon:k.Ikon||"🍶",
      db:Number(aktEsemeny[k["Tétel"]]),
      ar:arak[k["Tétel"]]||0,
      osszeg:Number(aktEsemeny[k["Tétel"]])*(arak[k["Tétel"]]||0),
    }));
    const etkezesArFo=Number(aktEsemeny["Étkezés ár (RSD/fő)"])||0;
    const vendegek=Number(aktEsemeny.Vendégek)||0;
    return{sorok,etkezesOssz:etkezesArFo*vendegek,etkezesArFo,vendegek};
  };

  const {sorok:totalSorok,etkezesOssz,etkezesArFo,vendegek:totalVendegek}=calcTotal();
  const italOssz=totalSorok.reduce((s,r)=>s+r.osszeg,0);
  const grandTotal=italOssz+etkezesOssz;
  const vanTotal=totalSorok.length>0||etkezesOssz>0;

  return (
    <>
      {/* HEADER */}
      <div className="tracker-header" style={{background:"linear-gradient(135deg, #1a1208 0%, #2d1f0a 100%)",borderBottom:"1px solid #4a3520",padding:"18px 18px 14px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <div>
          <div className="tracker-brand-tagline" style={{fontSize:10,letterSpacing:4,color:"#8a6a3a",textTransform:"uppercase",marginBottom:3}}>Géza Kátai Tanyája</div>
          <h1 className="tracker-brand-title" style={{margin:0,fontSize:19,fontWeight:"normal",color:"#e8d5a0"}}>🍷 Ital Fogyasztás</h1>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:7}}>
          {statusMsg&&<span style={{fontSize:11,color:statusMsg.startsWith("⚠")?"#d07070":"#80c060",display:"flex",alignItems:"center",gap:4}}>{saving&&<Spinner small/>}{statusMsg}</span>}
          <button onClick={load} disabled={loading} style={{background:"#1a2010",border:"1px solid #3a5020",borderRadius:7,color:"#80c060",fontSize:14,padding:"7px 10px",cursor:"pointer"}}>↺</button>
          <button onClick={()=>setUjEsemenyModal(true)} style={{...btn("#8a4a1a","#f0e8d8")}}>+ Új</button>
          <button onClick={onAdminClick} style={{background:"#1a1a2a",border:"1px solid #3a3a6a",borderRadius:7,color:"#8080c0",fontSize:14,padding:"7px 10px",cursor:"pointer"}}>🔒</button>
        </div>
      </div>

      {/* KERESŐ */}
      {aktEsemeny && !osszes && (
        <div className="tracker-search" style={{padding:"10px 15px 0"}}>
          <input
            value={kereső} onChange={e=>setKereső(e.target.value)}
            placeholder="🔍 Keresés..."
            style={{...inp,background:"#1a1208",border:"1px solid #3a2a18",padding:"8px 14px",fontSize:13}}
          />
        </div>
      )}

      {/* FÜLEK */}
      <div className={`tracker-tabs ${esemenyek.length===1?"single-event":""}`} style={{padding:"10px 15px 0",overflowX:"auto"}}>
        <div className="tracker-tabs-inner" style={{display:"flex",gap:7,paddingBottom:6,minWidth:"max-content"}}>
          {loading&&<div style={{display:"flex",alignItems:"center",gap:8,color:"#7a6a40",fontSize:12,padding:"10px 0"}}><Spinner small/>Betöltés...</div>}
          {!loading&&esemenyek.length===0&&<div style={{color:"#5a4a35",fontSize:13,padding:"10px 0"}}>Még nincs esemény — hozz létre egyet!</div>}
          {esemenyek.map(e=>{
            const akt=aktEsemeny?.id===e.id&&!osszes;
            return (
              <div key={e.id} style={{position:"relative"}}>
                <button onClick={()=>{setAktEsemeny(e);setOsszes(false);setKereső("");}} style={{background:akt?"#3d2a10":"#1a1208",border:akt?"1px solid #8a6a3a":"1px solid #3a2a18",borderRadius:9,padding:"7px 26px 7px 12px",color:akt?"#e8d5a0":"#9a8060",fontSize:12,cursor:"pointer",whiteSpace:"nowrap",fontFamily:"Georgia, serif"}}>
                  {e.Típus==="Ebéd"?"🍽":"🕯"} {e.Esemény}
                  <span className="event-tab-date" style={{display:"block",fontSize:10,opacity:0.6}}>{e.Dátum?new Date(e.Dátum).toLocaleDateString("hu-HU",{month:"short",day:"numeric"}):"—"}</span>
                </button>
                <button onClick={()=>setTorlésModal({type:"esemeny",target:e})} style={{position:"absolute",top:4,right:5,background:"transparent",border:"none",color:"#5a3a3a",fontSize:11,cursor:"pointer"}}>✕</button>
              </div>
            );
          })}
          {esemenyek.length>0&&(
            <button onClick={()=>{setOsszes(true);setAktEsemeny(null);setKereső("");}} style={{background:osszes?"#1a2a1a":"#1a1208",border:osszes?"1px solid #4a8a4a":"1px solid #3a2a18",borderRadius:9,padding:"7px 13px",color:osszes?"#a0e0a0":"#9a8060",fontSize:12,cursor:"pointer",fontFamily:"Georgia, serif"}}>📊 Összesítő</button>
          )}
        </div>
      </div>

      {/* AKTÍV ESEMÉNY */}
      {aktEsemeny&&!osszes&&(
        <div className="tracker-active" style={{padding:"10px 15px 180px"}}>
          <div className="event-card" style={{background:"#1a1208",border:"1px solid #4a3520",borderRadius:12,padding:"13px 16px",marginBottom:14,display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
            <div className="event-details">
              <div className="event-summary">
                <div style={{display:"flex",alignItems:"center",gap:7,fontSize:15,color:"#e8d5a0",marginBottom:2}}>
                  <span>{aktEsemeny.Esemény}</span>
                  <button onClick={()=>{setEsemenyNevInput(aktEsemeny.Esemény||"");setEsemenyNevModal(true);}} aria-label="Eseménynév szerkesztése" style={{background:"#241a0c",border:"1px solid #5a4020",borderRadius:5,color:"#b09050",fontSize:12,padding:"3px 6px",cursor:"pointer"}}>✏️</button>
                </div>
                <div style={{fontSize:11,color:"#6a5a40"}}>{formatDatum(aktEsemeny.Dátum)}</div>
              </div>
              <div className="guest-controls" style={{display:"flex",alignItems:"center",gap:6,marginTop:9}}>
                <span style={{fontSize:12,color:"#8a7a50",marginRight:2}}>👥 Vendégek</span>
                <button onClick={()=>lep("Vendégek",-1)} disabled={saving} aria-label="Vendégek számának csökkentése" style={{background:"#2a1010",border:"1px solid #5a2020",borderRadius:6,color:"#d07070",fontSize:17,width:30,height:30,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,touchAction:"manipulation"}}>−</button>
                <input type="number" min="0" inputMode="numeric"
                  value={inputCache.Vendégek!==undefined?inputCache.Vendégek:String(Number(aktEsemeny.Vendégek)||0)}
                  onChange={ev=>setInputCache(p=>({...p,Vendégek:ev.target.value}))}
                  onBlur={ev=>setVendegek(ev.target.value)}
                  onKeyDown={ev=>{if(ev.key==="Enter")ev.target.blur();}}
                  aria-label="Vendégek száma"
                  style={{width:52,textAlign:"center",background:"#0f0d0a",border:"1px solid #4a3520",borderRadius:6,color:"#e8d5a0",fontSize:16,padding:"4px 2px",fontFamily:"Georgia, serif",outline:"none"}}
                />
                <button onClick={()=>lep("Vendégek",1)} disabled={saving} aria-label="Vendégek számának növelése" style={{background:"#1a3010",border:"1px solid #3a6020",borderRadius:6,color:"#80c060",fontSize:17,width:30,height:30,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,touchAction:"manipulation"}}>+</button>
              </div>
              <div className="event-price-controls" style={{display:"flex",alignItems:"center",gap:6,marginTop:9}}>
                <span style={{fontSize:12,color:"#8a7a50",marginRight:2}}>🍽 Ár/fő</span>
                <button onClick={()=>lep("Étkezés ár (RSD/fő)",-100)} disabled={saving} aria-label="Étkezési ár csökkentése" style={{background:"#2a1010",border:"1px solid #5a2020",borderRadius:6,color:"#d07070",fontSize:17,width:30,height:30,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,touchAction:"manipulation"}}>−</button>
                <input type="number" min="0" step="100" inputMode="numeric"
                  value={inputCache["Étkezés ár (RSD/fő)"]!==undefined?inputCache["Étkezés ár (RSD/fő)"]:String(Number(aktEsemeny["Étkezés ár (RSD/fő)"])||0)}
                  onChange={ev=>setInputCache(p=>({...p,["Étkezés ár (RSD/fő)"]:ev.target.value}))}
                  onBlur={ev=>setDb("Étkezés ár (RSD/fő)",ev.target.value)}
                  onKeyDown={ev=>{if(ev.key==="Enter")ev.target.blur();}}
                  aria-label="Étkezés ára személyenként"
                  style={{width:68,textAlign:"center",background:"#0f0d0a",border:"1px solid #4a3520",borderRadius:6,color:"#e8d5a0",fontSize:16,padding:"4px 2px",fontFamily:"Georgia, serif",outline:"none"}}
                />
                <button onClick={()=>lep("Étkezés ár (RSD/fő)",100)} disabled={saving} aria-label="Étkezési ár növelése" style={{background:"#1a3010",border:"1px solid #3a6020",borderRadius:6,color:"#80c060",fontSize:17,width:30,height:30,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0,touchAction:"manipulation"}}>+</button>
              </div>
              <input
                className="compact-search"
                value={kereső}
                onChange={e=>setKereső(e.target.value)}
                placeholder="🔍 Keresés..."
                aria-label="Ital keresése"
              />
            </div>
          </div>

          <div className="drink-groups">
          {csoportok.map(csoport=>{
            const cItalok=szurtKonfig.filter(k=>(k.Csoport||"Egyéb")===csoport);
            if(!cItalok.length)return null;
            return (
              <div className="drink-group" key={csoport} style={{marginBottom:15}}>
                <div className="drink-group-title" style={{fontSize:11,color:"#c5a65a",fontWeight:"bold",letterSpacing:3,textTransform:"uppercase",marginBottom:7,padding:"5px 7px",background:"#211708",borderLeft:"4px solid #9a6f28",borderBottom:"1px solid #5a4020"}}>{csoport}</div>
                <div className="drink-items" style={{display:"flex",flexDirection:"column",gap:7}}>
                  {cItalok.map(ital=>{
                    const field=ital["Tétel"];
                    const db=Number(aktEsemeny[field])||0;
                    const cacheVal=inputCache[field];
                    const displayVal=cacheVal!==undefined?cacheVal:(db>0?String(db):"");
                    const ts=aktEsemeny._mod?.[field];
                    return (
                      <div className="drink-item" key={field} style={{background:db>0?"#1e180a":"#141008",border:db>0?"1px solid #5a4520":"1px solid #2a2010",borderRadius:11,padding:"10px 12px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                        <div className="drink-item-main" style={{display:"flex",alignItems:"center",gap:8,flex:1,minWidth:0}}>
                          <span className="drink-item-icon" style={{fontSize:19}}>{ital.Ikon||"🍶"}</span>
                          <div style={{minWidth:0}}>
                            <div className="drink-item-name" style={{fontSize:13,color:"#d8c590",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{field}</div>
                            <div className="drink-item-count" style={{fontSize:10,color:db>0?"#c0a050":"#4a3a25"}}>
                              {db>0?`${db} db`:"0"}
                            </div>
                          </div>
                        </div>
                        <div className="drink-controls" style={{display:"flex",alignItems:"center",gap:5,flexShrink:0}}>
                          <button onClick={()=>lep(field,-1)} disabled={saving} style={{background:"#2a1010",border:"1px solid #5a2020",borderRadius:6,color:"#d07070",fontSize:18,width:32,height:32,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0}}>−</button>
                          <input type="number" min="0" value={displayVal} placeholder="0"
                            onChange={ev=>setInputCache(p=>({...p,[field]:ev.target.value}))}
                            onBlur={ev=>setDb(field,ev.target.value)}
                            onKeyDown={ev=>{if(ev.key==="Enter"){setDb(field,ev.target.value);ev.target.blur();}}}
                            style={{width:46,textAlign:"center",background:"#0f0d0a",border:"1px solid #4a3520",borderRadius:6,color:"#e8d5a0",fontSize:15,padding:"4px 2px",fontFamily:"Georgia, serif",outline:"none"}}
                          />
                          <button onClick={()=>lep(field,1)} disabled={saving} style={{background:"#1a3010",border:"1px solid #3a6020",borderRadius:6,color:"#80c060",fontSize:18,width:32,height:32,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",padding:0}}>+</button>
                          {ts&&(
                            <div style={{position:"relative"}}>
                              <button onClick={()=>setTsTooltip(p=>p===field?null:field)} style={{background:"transparent",border:"none",color:"#5a6a50",fontSize:12,cursor:"pointer",padding:"2px 4px"}}>🕐</button>
                              {tsTooltip===field&&<div style={{position:"absolute",bottom:32,right:0,background:"#1a2a10",border:"1px solid #3a5a20",borderRadius:8,padding:"6px 10px",fontSize:11,color:"#a0c070",whiteSpace:"nowrap",zIndex:10}}>{formatTs(ts)}</div>}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
          </div>
          {szurtKonfig.length===0&&kereső&&<div style={{textAlign:"center",color:"#5a4a35",padding:"20px 0"}}>Nincs találat: "{kereső}"</div>}
        </div>
      )}

      {/* ÖSSZESÍTŐ */}
      {osszes&&(
        <div style={{padding:"16px"}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,flexWrap:"wrap",marginBottom:14}}>
            <div style={{fontSize:11,color:"#b4c878",letterSpacing:2,textTransform:"uppercase"}}>📊 Havi / éves összesítő</div>
            <div style={{display:"flex",gap:7}}>
              {[['month','Havi'],['year','Éves']].map(([id,label])=><button key={id} onClick={()=>{setOsszesMod(id);setOsszesPeriod("");}} style={{background:osszesMod===id?"#31451c":"#17160d",border:osszesMod===id?"1px solid #6e9238":"1px solid #3a351c",borderRadius:7,color:osszesMod===id?"#d7ec9a":"#817a54",padding:"7px 12px",fontFamily:"Georgia,serif",cursor:"pointer"}}>{label}</button>)}
              <select value={activePeriod} onChange={e=>setOsszesPeriod(e.target.value)} style={{background:"#17160d",border:"1px solid #5a5028",borderRadius:7,color:"#d8c989",padding:"7px 10px",fontFamily:"Georgia,serif",fontSize:14}}>
                {periodOptions.map(p=><option key={p} value={p}>{periodLabel(p)}</option>)}
              </select>
            </div>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(2,minmax(0,1fr))",gap:8,marginBottom:16}}>
            <div style={{background:"#1a1a0c",border:"1px solid #4a4a24",borderRadius:9,padding:"10px 13px"}}><div style={{fontSize:10,color:"#777344",textTransform:"uppercase",letterSpacing:1}}>Események</div><div style={{fontSize:22,color:"#e8d780",fontWeight:"bold"}}>{osszesEsemenyek.length}</div></div>
            <div style={{background:"#1a1a0c",border:"1px solid #4a4a24",borderRadius:9,padding:"10px 13px"}}><div style={{fontSize:10,color:"#777344",textTransform:"uppercase",letterSpacing:1}}>Vendégek összesen</div><div style={{fontSize:22,color:"#e8d780",fontWeight:"bold"}}>{osszesEsemenyek.reduce((s,e)=>s+(Number(e.Vendégek)||0),0)} fő</div></div>
          </div>
          {mindenCsoport.map(csoport=>{
            const rows=konfig.filter(k=>(k.Csoport||"Egyéb")===csoport).map(k=>({...k,total:osszesEsemenyek.reduce((s,e)=>s+(Number(e[k["Tétel"]])||0),0)})).filter(k=>k.total>0);
            if(!rows.length)return null;
            return <div key={csoport} style={{marginBottom:14}}>
              <div style={{fontSize:11,color:"#c5a65a",fontWeight:"bold",letterSpacing:3,textTransform:"uppercase",padding:"6px 8px",background:"#211708",borderLeft:"4px solid #9a6f28",borderBottom:"1px solid #5a4020",marginBottom:6}}>{csoport}</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",gap:6}}>
                {rows.map(k=><div key={k["Tétel"]} style={{background:"#1a1a08",border:"1px solid #4a4a20",borderRadius:8,padding:"10px 13px",display:"flex",justifyContent:"space-between",alignItems:"center"}}><span>{k.Ikon||"🍶"} <span style={{fontSize:13,color:"#d8d090"}}>{k["Tétel"]}</span></span><strong style={{fontSize:17,color:"#e8c870"}}>{k.total} db</strong></div>)}
              </div>
            </div>;
          })}
          <div style={{marginTop:12,fontSize:11,color:"#6f6a3d"}}>{periodLabel(activePeriod)} · {osszesEsemenyek.length} esemény összesítve</div>
        </div>
      )}

      {!aktEsemeny&&!osszes&&!loading&&esemenyek.length>0&&<div style={{padding:"40px",textAlign:"center",color:"#5a4a35"}}>Válassz eseményt fentről.</div>}

      {/* TOTAL GOMB - csak ha van fogyasztás */}
      {aktEsemeny&&!osszes&&vanTotal&&(
        <div className="tracker-actions" style={{position:"fixed",bottom:0,left:0,right:0,padding:"12px 15px",background:"linear-gradient(0deg, #0f0d0a 88%, transparent)",zIndex:50,display:"flex",flexDirection:"column",gap:8}}>
          <button onClick={()=>setTotalModal("final")} style={{width:"100%",background:"linear-gradient(135deg, #2a4a1a, #1a3a10)",border:"1px solid #5a9a30",borderRadius:12,padding:"14px",color:"#c0f070",fontSize:16,cursor:"pointer",fontFamily:"Georgia, serif",display:"flex",justifyContent:"center",alignItems:"center",gap:8,touchAction:"manipulation"}}>
            <span>💰 Total</span>
          </button>
          <button onClick={()=>setTotalModal("current")} style={{width:"100%",background:"linear-gradient(135deg, #3a2a12, #24190b)",border:"1px solid #8a6a2a",borderRadius:12,padding:"12px",color:"#e8d58a",fontSize:15,cursor:"pointer",fontFamily:"Georgia, serif",display:"flex",justifyContent:"center",alignItems:"center",gap:8,touchAction:"manipulation"}}>
            <span>📊 Jelenlegi állás</span>
          </button>
        </div>
      )}

      {/* TOTAL MODAL */}
      {totalModal&&aktEsemeny&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.92)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:200}}>
          <div style={{background:"#121a0a",border:"1px solid #4a8a20",borderRadius:"20px 20px 0 0",padding:"24px 20px 32px",width:"100%",maxWidth:520,maxHeight:"85vh",overflowY:"auto"}}>
            {/* Fejléc */}
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div>
                <div style={{fontSize:10,color:"#7a9a40",letterSpacing:3,textTransform:"uppercase"}}>{totalModal==="current"?"Jelenlegi állás":"Számla"}</div>
                <div style={{fontSize:16,color:"#d8e8b0",marginTop:2}}>{aktEsemeny.Esemény}</div>
                {aktEsemeny.Dátum&&<div style={{fontSize:11,color:"#5a7a40",marginTop:2}}>{formatDatum(aktEsemeny.Dátum)}</div>}
                {totalModal==="current"&&<div style={{fontSize:11,color:"#7a9a50",marginTop:4}}>Az eddigi fogyasztás alapján</div>}
              </div>
              <button onClick={()=>setTotalModal(null)} style={{background:"transparent",border:"none",color:"#6a8a40",fontSize:22,cursor:"pointer"}}>✕</button>
            </div>

            {/* ÉTKEZÉS blokk */}
            {etkezesArFo>0&&(
              <div style={{background:"#1a2a1a",border:"1px solid #4a6a20",borderRadius:12,padding:"14px 16px",marginBottom:12}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <div style={{fontSize:14,color:"#d0e890",fontWeight:"bold"}}>🍽 {aktEsemeny.Típus==="Ebéd"?"Ebéd":"Vacsora"}</div>
                    <div style={{fontSize:12,color:"#6a8a40",marginTop:3}}>{totalVendegek} fő × {fmtRSD(etkezesArFo)}</div>
                  </div>
                  <div style={{fontSize:18,color:"#b0e860",fontWeight:"bold"}}>{fmtRSD(etkezesOssz)}</div>
                </div>
              </div>
            )}

            {/* ITALOK blokk */}
            {totalSorok.length>0&&(
              <div style={{background:"#1a2a0a",border:"1px solid #3a5a18",borderRadius:12,padding:"14px 16px",marginBottom:12}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                  <div style={{fontSize:14,color:"#d0e890",fontWeight:"bold"}}>🍷 Italok összesen</div>
                  <div style={{fontSize:18,color:"#b0e860",fontWeight:"bold"}}>{fmtRSD(italOssz)}</div>
                </div>
                <div style={{borderTop:"1px solid #2a4a18",paddingTop:10,display:"flex",flexDirection:"column",gap:6}}>
                  {totalSorok.map(r=>(
                    <div key={r.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div style={{display:"flex",alignItems:"center",gap:6}}>
                        <span style={{fontSize:15}}>{r.ikon}</span>
                        <span style={{fontSize:12,color:"#a0c070"}}>{r.id}</span>
                      </div>
                      <div style={{textAlign:"right"}}>
                        <span style={{fontSize:12,color:"#6a8a40",marginRight:8}}>{r.db} db</span>
                        <span style={{fontSize:13,color:r.ar>0?"#90d060":"#5a7a40",fontWeight:"bold"}}>{r.ar>0?fmtRSD(r.osszeg):"—"}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* VÉGÖSSZEG */}
            <div style={{borderTop:"2px solid #4a7a20",paddingTop:16,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{fontSize:13,color:"#7a9a40",letterSpacing:2,textTransform:"uppercase"}}>Végösszeg</div>
              <div style={{fontSize:28,color:"#c0f070",fontWeight:"bold"}}>{fmtRSD(grandTotal)}</div>
            </div>

            {/* PDF LETÖLTÉS / NYOMTATÁS */}
            {totalModal==="final"&&(
              <a
                href={`/api/esemenyek/${aktEsemeny.id}/pdf`}
                target="_blank"
                rel="noopener noreferrer"
                style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,marginTop:20,width:"100%",background:"linear-gradient(135deg, #5a7f2a, #3f641c)",border:"1px solid #86b64a",borderRadius:12,padding:"14px",color:"#f3ffe3",fontSize:16,fontWeight:"bold",textDecoration:"none",fontFamily:"Georgia, serif",boxSizing:"border-box",touchAction:"manipulation"}}
              >
                <span>⬇️ PDF letöltése / nyomtatása</span>
              </a>
            )}
          </div>
        </div>
      )}

      {/* ESEMÉNYNÉV SZERKESZTÉSE */}
      {esemenyNevModal&&aktEsemeny&&(
        <Modal>
          <h3 style={{margin:"0 0 18px",color:"#e8d5a0",fontWeight:"normal",fontSize:17}}>Esemény nevének szerkesztése</h3>
          <div style={{marginBottom:20}}><label style={lbl}>Esemény neve</label><input value={esemenyNevInput} onChange={e=>setEsemenyNevInput(e.target.value)} onKeyDown={e=>e.key==="Enter"&&saveEsemenyNev()} style={inp} autoFocus/></div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>setEsemenyNevModal(false)} style={{...btn("transparent","#6a5040"),flex:1,border:"1px solid #3a2a18"}}>Mégse</button>
            <button onClick={saveEsemenyNev} disabled={saving||!esemenyNevInput.trim()} style={{...btn(saving?"#5a3a1a":"#8a4a1a","#f0e8d8"),flex:2}}>Mentés</button>
          </div>
        </Modal>
      )}

      {/* ÚJ ESEMÉNY MODAL */}
      {ujEsemenyModal&&(
        <Modal>
          <h3 style={{margin:"0 0 18px",color:"#e8d5a0",fontWeight:"normal",fontSize:17}}>Új esemény</h3>
          <div style={{marginBottom:12}}><label style={lbl}>Esemény neve</label><input value={ujNev} onChange={e=>setUjNev(e.target.value)} placeholder="pl. Kovács esküvő" style={inp} autoFocus/></div>
          <div style={{display:"flex",gap:8,marginBottom:12}}>
            {["Ebéd","Vacsora"].map(t=>(
              <button key={t} onClick={()=>setUjTipus(t)} style={{flex:1,background:ujTipus===t?"#3d2a10":"#1e1608",border:ujTipus===t?"1px solid #8a6a3a":"1px solid #3a2a18",borderRadius:8,padding:"9px",color:ujTipus===t?"#e8d5a0":"#6a5040",cursor:"pointer",fontSize:13,fontFamily:"Georgia, serif"}}>{t==="Ebéd"?"🍽 Ebéd":"🕯 Vacsora"}</button>
            ))}
          </div>
          <div style={{marginBottom:12}}><label style={lbl}>Dátum</label><input type="date" value={ujDatum} onChange={e=>setUjDatum(e.target.value)} style={inp}/></div>
          <div style={{marginBottom:12}}><label style={lbl}>Vendégek száma</label><input type="number" value={ujVendegek} onChange={e=>setUjVendegek(e.target.value)} placeholder="pl. 25" style={inp}/></div>
          <div style={{marginBottom:20}}><label style={lbl}>Étkezés ára (RSD / fő)</label><input type="number" value={ujEtkezesAr} onChange={e=>setUjEtkezesAr(e.target.value)} placeholder="pl. 1500" style={inp}/></div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>setUjEsemenyModal(false)} style={{...btn("transparent","#6a5040"),flex:1,border:"1px solid #3a2a18"}}>Mégse</button>
            <button onClick={esemenyLetrehozas} disabled={saving} style={{...btn(saving?"#5a3a1a":"#8a4a1a","#f0e8d8"),flex:2,display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>{saving?<><Spinner small/>Mentés...</>:"Létrehozás"}</button>
          </div>
        </Modal>
      )}

      {/* TÖRLÉS MODAL */}
      {torlésModal&&(
        <Modal borderColor="#6a2a2a">
          <div style={{fontSize:24,textAlign:"center",marginBottom:12}}>🗑️</div>
          <h3 style={{margin:"0 0 10px",color:"#e8a0a0",fontWeight:"normal",fontSize:16,textAlign:"center"}}>Esemény törlése?</h3>
          <p style={{fontSize:13,color:"#8a6a6a",textAlign:"center",margin:"0 0 20px"}}>"{torlésModal.target.Esemény}" törlődik Notionból.</p>
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>setTorlésModal(null)} style={{...btn("transparent","#8a6a6a"),flex:1,border:"1px solid #4a2a2a"}}>Mégse</button>
            <button onClick={()=>esemenyTorol(torlésModal.target)} disabled={saving} style={{...btn(saving?"#4a1a1a":"#7a1a1a","#f0c0c0"),flex:2,display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>{saving?<><Spinner small/>Törlés...</>:"Törlés"}</button>
          </div>
        </Modal>
      )}
    </>
  );
}

function AdminPage({onBack}) {
  const [aktTab,setAktTab]=useState("arak"); // "arak" | "tetelek"
  const [arak,setArak]=useState([]);
  const [konfig,setKonfig]=useState([]);
  const [loading,setLoading]=useState(false);
  const [saving,setSaving]=useState(false);
  const [statusMsg,setStatusMsg]=useState("");
  const [arCache,setArCache]=useState({});
  const [dragIdx,setDragIdx]=useState(null);

  const [ujTetelModal,setUjTetelModal]=useState(false);
  const [ujTetelNev,setUjTetelNev]=useState("");
  const [ujTetelIkon,setUjTetelIkon]=useState("🍶");
  const [ujTetelCsoport,setUjTetelCsoport]=useState("Egyéb");

  const [szerkModal,setSzerkModal]=useState(null); // konfig row

  const status=(msg,ms=2500)=>{setStatusMsg(msg);if(ms)setTimeout(()=>setStatusMsg(""),ms);};

  const load=useCallback(async()=>{
    setLoading(true);setStatusMsg("Betöltés...");
    try {
      const [aRes,kRes]=await Promise.all([fetch("/api/arak").then(r=>r.json()),fetch("/api/konfig").then(r=>r.json())]);
      if(aRes.results)setArak(aRes.results.map(pageToRow));
      if(kRes.results)setKonfig(kRes.results.map(pageToRow).sort((a,b)=>(a.Sorrend||99)-(b.Sorrend||99)));
      setStatusMsg("");
    } catch{status("⚠️ Betöltési hiba",0);}
    setLoading(false);
  },[]);

  useEffect(()=>{load();},[load]);

  const saveAr=async(row,newAr)=>{
    setSaving(true);setStatusMsg("Mentés...");
    setArak(prev=>prev.map(r=>r.id===row.id?{...r,"Ár (RSD)":newAr}:r));
    try { await fetch(`/api/arak/${row.id}`,{method:"PATCH",headers:{"Content-Type":"application/json"},body:JSON.stringify({"Ár (RSD)":{number:newAr}})}); status("✓ Mentve"); }
    catch{status("⚠️ Hiba",0);}
    setSaving(false);
  };

  const saveKonfig=async(row,updates)=>{
    setSaving(true);setStatusMsg("Mentés...");
    setKonfig(prev=>prev.map(r=>r.id===row.id?{...r,...updates}:r));
    const props={};
    if(updates["Tétel"]!==undefined) props["Tétel"]={title:[{text:{content:updates["Tétel"].trim()}}]};
    if(updates.Ikon!==undefined) props.Ikon={rich_text:[{text:{content:updates.Ikon}}]};
    if(updates.Csoport!==undefined) props.Csoport={rich_text:[{text:{content:updates.Csoport}}]};
    if(updates.Sorrend!==undefined) props.Sorrend={number:updates.Sorrend};
    try {
      const res=await fetch(`/api/konfig/${row.id}`,{method:"PATCH",headers:{"Content-Type":"application/json"},body:JSON.stringify(props)});
      if(!res.ok){const data=await res.json().catch(()=>({}));throw new Error(data.error||"Hiba");}
      status("✓ Mentve");await load();setSaving(false);return true;
    }
    catch(e){await load();status(`⚠️ ${e.message||"Hiba"}`,0);setSaving(false);return false;}
  };

  const ujTetelHozzaad=async()=>{
    if(!ujTetelNev.trim())return;
    setSaving(true);setStatusMsg("Létrehozás...");
    try {
      const res=await fetch("/api/konfig",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({tetel:ujTetelNev,ikon:ujTetelIkon,csoport:ujTetelCsoport,sorrend:konfig.length+1})});
      setUjTetelModal(false);setUjTetelNev("");setUjTetelIkon("🍶");setUjTetelCsoport("Egyéb");
      status("✓ Létrehozva");await load();
    } catch{status("⚠️ Hiba",0);}
    setSaving(false);
  };

  const tetelTorol=async(row)=>{
    setSaving(true);setStatusMsg("Törlés...");
    try {
      const res=await fetch(`/api/konfig/${row.id}`,{method:"DELETE"});
      if(!res.ok)throw new Error("Törlési hiba");
      setKonfig(prev=>prev.filter(r=>r.id!==row.id));
      setArak(prev=>prev.filter(r=>r["Tétel"]!==row["Tétel"]));
      status("✓ Tétel és ára törölve");
    }
    catch{status("⚠️ Hiba",0);}
    setSaving(false);
  };

  return (
    <>
      <div style={{background:"linear-gradient(135deg, #0f0f1a 0%, #1a1a2d 100%)",borderBottom:"1px solid #3a3a6a",padding:"18px 18px 14px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <div>
          <div style={{fontSize:10,letterSpacing:4,color:"#6a6a9a",textTransform:"uppercase",marginBottom:3}}>Admin</div>
          <h1 style={{margin:0,fontSize:19,fontWeight:"normal",color:"#c0c0e8"}}>🔒 Beállítások</h1>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          {statusMsg&&<span style={{fontSize:11,color:statusMsg.startsWith("⚠")?"#d07070":"#80c060",display:"flex",alignItems:"center",gap:4}}>{saving&&<Spinner small/>}{statusMsg}</span>}
          <button onClick={load} disabled={loading} style={{background:"#1a1a2a",border:"1px solid #3a3a6a",borderRadius:7,color:"#8080c0",fontSize:14,padding:"7px 10px",cursor:"pointer"}}>↺</button>
          <button onClick={onBack} style={{...btn("#2a1a0a","#c0a060"),border:"1px solid #5a4020"}}>← Vissza</button>
        </div>
      </div>

      {/* TABOK */}
      <div style={{display:"flex",gap:0,borderBottom:"1px solid #2a2a4a"}}>
        {[["arak","💰 Árlap"],["tetelek","🍶 Tételek"]].map(([id,label])=>(
          <button key={id} onClick={()=>setAktTab(id)} style={{flex:1,background:aktTab===id?"#1a1a2a":"transparent",border:"none",borderBottom:aktTab===id?"2px solid #6060c0":"2px solid transparent",color:aktTab===id?"#c0c0f8":"#6a6a9a",padding:"12px",fontSize:13,cursor:"pointer",fontFamily:"Georgia, serif"}}>{label}</button>
        ))}
      </div>

      <div style={{padding:"16px 15px"}}>
        {/* ÁRLAP TAB */}
        {aktTab==="arak"&&(
          <>
            <div style={{fontSize:11,color:"#5a5a8a",marginBottom:16,padding:"10px 14px",background:"#0f0f1a",border:"1px solid #2a2a5a",borderRadius:8}}>
              💡 Az árak RSD-ben. A személyzet ezt nem látja.
            </div>
            {loading&&<div style={{display:"flex",alignItems:"center",gap:8,color:"#6a6a9a",fontSize:13,padding:"20px 0"}}><Spinner small/>Betöltés...</div>}
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {arak.map(row=>{
                const cacheVal=arCache[row.id];
                const displayVal=cacheVal!==undefined?cacheVal:(row["Ár (RSD)"]||"");
                return (
                  <div key={row.id} style={{background:"#0f0f1a",border:"1px solid #2a2a5a",borderRadius:11,padding:"12px 14px",display:"flex",alignItems:"center",justifyContent:"space-between",gap:12}}>
                    <div style={{flex:1}}><div style={{fontSize:14,color:"#c0c0e8"}}>{row["Tétel"]}</div><div style={{fontSize:11,color:"#5a5a8a"}}>{row["Egység"]||"db"}</div></div>
                    <div style={{display:"flex",alignItems:"center",gap:6}}>
                      <input type="number" min="0" value={displayVal} placeholder="0"
                        onChange={ev=>setArCache(p=>({...p,[row.id]:ev.target.value}))}
                        onBlur={ev=>{const v=parseFloat(ev.target.value);const uj=isNaN(v)||v<0?0:v;setArCache(p=>{const n={...p};delete n[row.id];return n;});if(uj!==row["Ár (RSD)"])saveAr(row,uj);}}
                        onKeyDown={ev=>{if(ev.key==="Enter")ev.target.blur();}}
                        style={{width:90,textAlign:"right",background:"#1a1a2a",border:"1px solid #3a3a6a",borderRadius:7,color:"#c0c0f8",fontSize:15,padding:"7px 10px",fontFamily:"Georgia, serif",outline:"none"}}
                      />
                      <span style={{fontSize:12,color:"#5a5a8a"}}>RSD</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}

        {/* TÉTELEK TAB */}
        {aktTab==="tetelek"&&(
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
              <div style={{fontSize:11,color:"#5a5a8a"}}>A név, kategória, ikon és sorrend itt biztonságosan szerkeszthető</div>
              <button onClick={()=>setUjTetelModal(true)} style={{...btn("#1a2a3a","#80c0e0"),border:"1px solid #3a6a8a",fontSize:12,padding:"7px 12px"}}>+ Új tétel</button>
            </div>
            {loading&&<div style={{display:"flex",alignItems:"center",gap:8,color:"#6a6a9a",fontSize:13,padding:"20px 0"}}><Spinner small/>Betöltés...</div>}
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {konfig.map((row,idx)=>(
                <div key={row.id} style={{background:"#0f0f1a",border:"1px solid #2a2a5a",borderRadius:11,padding:"12px 14px",display:"flex",alignItems:"center",gap:10}}>
                  <span style={{fontSize:22,flexShrink:0}}>{row.Ikon||"🍶"}</span>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:13,color:"#c0c0e8",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{row["Tétel"]}</div>
                    <div style={{fontSize:11,color:"#5a5a8a"}}>{row.Csoport||"Egyéb"} · #{row.Sorrend||idx+1}</div>
                  </div>
                  <div style={{display:"flex",gap:6}}>
                    <button onClick={()=>setSzerkModal(row)} style={{background:"#1a2a3a",border:"1px solid #3a5a7a",borderRadius:7,color:"#80b0d0",fontSize:12,padding:"5px 10px",cursor:"pointer"}}>✏️</button>
                    <button onClick={()=>tetelTorol(row)} style={{background:"#2a1010",border:"1px solid #5a2020",borderRadius:7,color:"#d07070",fontSize:12,padding:"5px 10px",cursor:"pointer"}}>🗑</button>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      {/* ÚJ TÉTEL MODAL */}
      {ujTetelModal&&(
        <Modal borderColor="#3a6a8a">
          <h3 style={{margin:"0 0 18px",color:"#80c0e0",fontWeight:"normal",fontSize:17}}>Új tétel</h3>
          <div style={{marginBottom:12}}><label style={lbl}>Megnevezés</label><input value={ujTetelNev} onChange={e=>setUjTetelNev(e.target.value)} placeholder="pl. Prosecco 0.75L" style={inp} autoFocus/></div>
          <div style={{marginBottom:12}}>
            <label style={lbl}>Ikon</label>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              {IKONOK.map(ik=><button key={ik} onClick={()=>setUjTetelIkon(ik)} style={{background:ujTetelIkon===ik?"#2a2a10":"#141008",border:ujTetelIkon===ik?"1px solid #8a8a20":"1px solid #2a2010",borderRadius:7,padding:"5px 7px",fontSize:18,cursor:"pointer"}}>{ik}</button>)}
            </div>
          </div>
          <div style={{marginBottom:20}}>
            <label style={lbl}>Csoport</label>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              {[...CSOPORTOK_SORREND].map(cs=><button key={cs} onClick={()=>setUjTetelCsoport(cs)} style={{background:ujTetelCsoport===cs?"#1a2a3a":"#141008",border:ujTetelCsoport===cs?"1px solid #3a6a8a":"1px solid #2a2010",borderRadius:7,padding:"6px 10px",color:ujTetelCsoport===cs?"#80c0e0":"#6a5a40",fontSize:11,cursor:"pointer",fontFamily:"Georgia, serif"}}>{cs}</button>)}
            </div>
          </div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>setUjTetelModal(false)} style={{...btn("transparent","#6a5040"),flex:1,border:"1px solid #3a2a18"}}>Mégse</button>
            <button onClick={ujTetelHozzaad} disabled={saving} style={{...btn(saving?"#1a3a5a":"#1a4a6a","#c0e8f8"),flex:2,display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>{saving?<><Spinner small/>Létrehozás...</>:"Hozzáadás"}</button>
          </div>
        </Modal>
      )}

      {/* SZERKESZTÉS MODAL */}
      {szerkModal&&(
        <Modal borderColor="#3a6a8a">
          <h3 style={{margin:"0 0 4px",color:"#80c0e0",fontWeight:"normal",fontSize:17}}>✏️ Szerkesztés</h3>
          <div style={{margin:"14px 0"}}><label style={lbl}>Tétel neve</label><input value={szerkModal["Tétel"]||""} onChange={e=>setSzerkModal(p=>({...p,["Tétel"]:e.target.value}))} style={inp}/></div>
          <div style={{marginBottom:14}}>
            <label style={lbl}>Ikon</label>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              {IKONOK.map(ik=><button key={ik} onClick={()=>setSzerkModal(p=>({...p,Ikon:ik}))} style={{background:szerkModal.Ikon===ik?"#2a2a10":"#141008",border:szerkModal.Ikon===ik?"1px solid #8a8a20":"1px solid #2a2010",borderRadius:7,padding:"5px 7px",fontSize:18,cursor:"pointer"}}>{ik}</button>)}
            </div>
          </div>
          <div style={{marginBottom:14}}>
            <label style={lbl}>Csoport</label>
            <input value={szerkModal.Csoport||""} onChange={e=>setSzerkModal(p=>({...p,Csoport:e.target.value}))} placeholder="Kategória neve" style={{...inp,marginBottom:8}}/>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              {[...CSOPORTOK_SORREND].map(cs=><button key={cs} onClick={()=>setSzerkModal(p=>({...p,Csoport:cs}))} style={{background:szerkModal.Csoport===cs?"#1a2a3a":"#141008",border:szerkModal.Csoport===cs?"1px solid #3a6a8a":"1px solid #2a2010",borderRadius:7,padding:"6px 10px",color:szerkModal.Csoport===cs?"#80c0e0":"#6a5a40",fontSize:11,cursor:"pointer",fontFamily:"Georgia, serif"}}>{cs}</button>)}
            </div>
          </div>
          <div style={{marginBottom:20}}>
            <label style={lbl}>Sorrend (#)</label>
            <input type="number" value={szerkModal.Sorrend||""} onChange={e=>setSzerkModal(p=>({...p,Sorrend:parseInt(e.target.value)||1}))} style={inp}/>
          </div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>setSzerkModal(null)} style={{...btn("transparent","#6a5040"),flex:1,border:"1px solid #3a2a18"}}>Mégse</button>
            <button onClick={async()=>{if(await saveKonfig(szerkModal,{"Tétel":szerkModal["Tétel"],Ikon:szerkModal.Ikon,Csoport:szerkModal.Csoport,Sorrend:szerkModal.Sorrend}))setSzerkModal(null);}} disabled={saving||!szerkModal["Tétel"]?.trim()} style={{...btn(saving?"#1a3a5a":"#1a4a6a","#c0e8f8"),flex:2,display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>{saving?<><Spinner small/>Mentés...</>:"Mentés"}</button>
          </div>
        </Modal>
      )}
    </>
  );
}
